import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { AuthLayout, AuthInput, AuthAlert, PrimaryButton, SecondaryButton, OutlineButton } from './layout/AuthLayout';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const response = await authService.forgotPassword(email);
      setMessage(response.message);
      if (response.token) {
        setResetToken(response.token);
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error sending reset request');
    }
  };

  return (
    <AuthLayout title="Forgot Password" subtitle="Enter your email address to receive a password reset token">
      {error && <AuthAlert severity="error">{error}</AuthAlert>}
      {message && <AuthAlert severity="success">{message}</AuthAlert>}
      {resetToken && (
        <AuthAlert severity="info">
          <p className="m-0 font-bold">Reset Token:</p>
          <p className="m-0 mt-1 break-all font-mono text-[11px]">{resetToken}</p>
          <p className="m-0 mt-2 text-[11px] opacity-80">Copy this token and use it on the reset password page</p>
        </AuthAlert>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <AuthInput
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@mqbit.in"
          required
        />
        <div className="pt-2">
          <PrimaryButton type="submit">Send Reset Token</PrimaryButton>
        </div>
        {resetToken && (
          <OutlineButton type="button" onClick={() => navigate('/reset-password')}>
            Go to Reset Password
          </OutlineButton>
        )}
        <SecondaryButton type="button" onClick={() => navigate('/login')}>
          Back to Login
        </SecondaryButton>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
